import { createActions, createReducer } from 'reduxsauce';

const initialState = {
  isLoading: false,

  page: 0,
  perPage: 10,
  search: {},

  profile: {},
  data: []
}

// Cria os action types e creators
export const { Types, Creators } = createActions({
  profileChangePageRequest: ['page', 'search'],
  profileChangePageSuccess: ['data'],
  profileChangePageFailure: ['data'],

  setProfile: ['profile']
});

// Criando os reducers handle
const profileChangePageRequest = (state = initialState, action) => ({
  ...state,
  isLoading: true,
  page: action.page,
  perPage: action.perPage
});

const profileChangePageSuccess = (state = initialState, action) => ({
  ...state, 
  isLoading: false,
  data: action.data
});

const profileChangePageFailure = (state = initialState, action) => ({
  ...state, 
  isLoading: false, 
  error: action.data
});

const setProfile = (state = initialState, action) => ({
  ...state, 
  profile: action.profile
});

// Criando reducer
export default createReducer(initialState, {
  [Types.PROFILE_CHANGE_PAGE_REQUEST]: profileChangePageRequest,
  [Types.PROFILE_CHANGE_PAGE_SUCCESS]: profileChangePageSuccess,
  [Types.PROFILE_CHANGE_PAGE_FAILURE]: profileChangePageFailure,

  [Types.SET_PROFILE]: setProfile,
});
